(function() {
  'use strict';

  /* --- Dynamic Date --- */
  var dateEls = document.querySelectorAll('[data-adv-date]');
  if (dateEls.length) {
    var months = ['ינואר','פברואר','מרץ','אפריל','מאי','יוני','יולי','אוגוסט','ספטמבר','אוקטובר','נובמבר','דצמבר'];
    var d = new Date();
    var dateStr = d.getDate() + ' ב' + months[d.getMonth()] + ', ' + d.getFullYear();
    dateEls.forEach(function(el) { el.textContent = dateStr; });
  }

  /* --- Sticky Bar --- */
  var sticky = document.querySelector('.adv-sticky');
  var trigger = document.getElementById('adv-product-reveal');
  var footer = document.querySelector('.adv-footer');

  if (sticky && trigger) {
    var showBar = false;
    window.addEventListener('scroll', function() {
      var triggerTop = trigger.getBoundingClientRect().top;
      var footerTop = footer ? footer.getBoundingClientRect().top : 99999;
      var windowH = window.innerHeight;

      if (triggerTop < windowH * 0.5 && footerTop > windowH) {
        if (!showBar) { sticky.classList.add('visible'); showBar = true; }
      } else {
        if (showBar) { sticky.classList.remove('visible'); showBar = false; }
      }
    }, { passive: true });
  }

  /* --- Product Slider --- */
  var track = document.querySelector('.adv-slider-track');
  var prevBtn = document.querySelector('.adv-slider-prev');
  var nextBtn = document.querySelector('.adv-slider-next');

  if (track && prevBtn && nextBtn) {
    var slideWidth = function() {
      var img = track.querySelector('img');
      return img ? img.offsetWidth + 12 : 300;
    };
    nextBtn.addEventListener('click', function() {
      track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });
    prevBtn.addEventListener('click', function() {
      track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });
  }
})();
